module.exports = __webpack_public_path__ + "media/images/common-nav/national-parks/grand_canyon_national_park-4ba04dbb316e0c5e4f1f271bdd46b89f.jpg";